import { getCurrentUrl } from './ApiServices';

const logPerProcess: { 
    [key: number]: { 
        isProcessing: boolean, 
        error: string, 
        logs:  string[], 
        onReceiveDatas?: ((data: string) => void) | null
        onDoneCallback?: (() => void) | null
        onCrashCalllback?: ((error:any) => void) | null
    }, 
} = {};
/**
 * Attache ou supprime (si null) un callback de reception des données streamer
 */
export function setOnReceiveDatasCallback(processId: number, onReceiveDatasCallback: ((data: string) => void) | null): void{
    logPerProcess[processId].onReceiveDatas = onReceiveDatasCallback;     
}
/**
 * Attache ou supprime (si null) un callback de fin de processus
 */
export function setOnDoneCallback(processId: number, onDoneCallback: (() => void) | null): void{
    logPerProcess[processId].onDoneCallback = onDoneCallback;     
}
/**
 * Attache ou supprime (si null) un callback d'erreur
 */
export function setOnCrashCalllback(processId: number, onCrashCalllback: ((error:any) => void) | null): void{
    logPerProcess[processId].onCrashCalllback = onCrashCalllback;     
}
/**
 * retourne ou crée l'instance d'un processus via son id, le suivie d'un processus reste toujours unique par type différant de processus
 */
export function getProcessById(processId: number){
    if(!logPerProcess[processId]){
        logPerProcess[processId] = { logs : [], isProcessing : false, error: ''};
    }
    return logPerProcess[processId];
}
/**
 * remet tous les processus à zéro
 */
export function resetProcessLog(){
    Object.keys(logPerProcess).forEach((key: string)=>{
        const ikey = parseInt(key, 10);
        logPerProcess[ikey].logs = [];
        logPerProcess[ikey].isProcessing = false;
        logPerProcess[ikey].error = '';
    })
}

/**
 * Fonction de prise en charge du stream serveur du retour applicatif node des ETLS
*/
async function pumpStream(processId: number, reader: ReadableStreamDefaultReader, controller: ReadableStreamDefaultController):Promise<void> {
    return reader.read().then( ( streamResult: ReadableStreamReadResult<Uint8Array> ) => {
        const done: boolean = streamResult.done;
        const value: Uint8Array|undefined = streamResult.value;
        const text = new TextDecoder().decode(value);
        const { logs, onReceiveDatas, onDoneCallback, onCrashCalllback } = logPerProcess[processId];
        
        if(text){
            // Analyse de la réponse de fin du serveur, celle ci nous permet de savoir que c'est le status finale
            // Elle a été ajouter car une fois le stream commencé, le status http ne peu pas changer (il reste en 200)
            // le serveur envoie donc un message de fin avec l'erreur s'il y en a une, sinon il envoi un messag de fin avec un success     
            
            if(text.indexOf('@END=') !== -1){
                const endMessage = text.split('@END=')[1];
                if(endMessage.indexOf('Error') !== -1){
                    logPerProcess[processId].error = endMessage;
                    onCrashCalllback && onCrashCalllback(new Error(endMessage))
                    logPerProcess[processId].isProcessing = false;
                } else {                
                    logPerProcess[processId].isProcessing = false;
                    onDoneCallback && onDoneCallback();
                }
            } else {
                logs.push(text);
                if(onReceiveDatas) onReceiveDatas(text);
                if (done) {
                    logPerProcess[processId].isProcessing = false;
                    return;
                }     
            }
        }
        // on ferme le stream une fois que le status nous donne l'indication que c'est terminé
        if (done) {
            // on ajoute un done de sécurité en cas de non réponse, mais de stream terminé sans erreur
            if(logPerProcess[processId].isProcessing === true){
                onDoneCallback && onDoneCallback();
            }
            controller.close();
            return;
        }        
        // si le stream continue on continue de le lire
        controller.enqueue(value);
        return pumpStream(processId, reader, controller);
        
    }).catch((e)=>{
       throw e; 
    });
}

/**
 * Lance un etl en streaming
 */
export function streamProcess(processId: number):Promise<void> {
    const requestOptions = {
        headers: {
            'Authorization': `JWT ${localStorage.getItem("token")}`
        },
        method: 'POST',
    };
    const process = getProcessById(processId);
    process.error = '';
    process.logs = [];
    process.isProcessing = true;
    const streamDonePromise:Promise<void> = new Promise((resolve, reject)=>{
        fetch(`${getCurrentUrl()}/process/launch/${processId}`, requestOptions)
            // Requète spécial qui va nous envoyer les données en plain text et en streaming le but étant d'avoir les logs en temps réel
            .then((response) => {
                if(response && response.body){
                    if(response.status === 200){
                        const reader = response.body.getReader();
                        return new ReadableStream({
                        start(controller) {
                            return pumpStream(processId, reader, controller).then(() => {
                                resolve();
                            }).catch((error)=>{
                                process.onCrashCalllback && process.onCrashCalllback(error);
                            });
                        },
                        });
                    } else {
                        response.text().then((txtResponse)=>{
                            reject(new Error(txtResponse));
                        }).catch(()=>{
                            reject(new Error('No response'));
                        })
                    }
                } else {
                    reject(new Error('No response'));
                }
            })
         .catch(reject);
    });

    return streamDonePromise.catch((err)=>{
        process.isProcessing = false;
        process.onCrashCalllback && process.onCrashCalllback(err);
    })
}
